import { createContext } from "react";

const MapManagementContext = createContext();

export default MapManagementContext;
